/*
 * NYORD: Videos der Startseite zeigen ihr Vorschaubild als <img class="nb-video-poster"> über dem Video, bis das Video
 * wirklich läuft; dann blendet das Bild aus. Bei gesperrtem Autoplay (iOS-Stromsparmodus, Brave) bleibt so das ruhige
 * Vorschaubild stehen statt des nativen Play-Knopfs. Das Video selbst bleibt sichtbar, damit iOS es abspielen darf.
 *
 * Videos mit data-nb-sicht haben kein autoplay und preload="none": Sie laden und laufen erst, wenn sie zu einem guten
 * Teil im Bild sind, und halten außerhalb an. Mit data-nb-nach-bild (Hero) startet das Video außerdem erst, wenn das
 * Vorschaubild steht: Sonst teilt sich das größte Bild der Seite die Leitung mit mehreren MB Video.
 * Wer selbst auf Pause drückt (nb-video-pause setzt video.nbSelbst), behält die Kontrolle.
 */
(function () {
  if (window.nbVideoBereit) return;
  window.nbVideoBereit = true;
  var AUSWAHL = '.nb-hero__medium video, .nb-bruch video, .nb-buehne__karte video, .nb-spot__bild--video video';
  var reduziert = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function binden(video) {
    if (video.nbGebunden) return;
    video.nbGebunden = true;
    var poster = video.parentElement.querySelector('.nb-video-poster');
    if (video.hasAttribute('data-nb-sicht')) sichtbarAbspielen(video, poster);
    if (!poster) return;
    // Erst ausblenden, wenn das Video wirklich vorrückt: ein abgebrochener Autoplay-Versuch meldet sonst schon „playing“
    var pruefen = function () {
      if (video.paused || video.currentTime < 0.1) return;
      poster.classList.add('nb-video-poster--weg');
      video.removeEventListener('timeupdate', pruefen);
    };
    video.addEventListener('timeupdate', pruefen);
    pruefen();
  }

  function sichtbarAbspielen(video, poster) {
    if (reduziert || !('IntersectionObserver' in window)) return;
    var sichtbar = false;
    var bereit = !video.hasAttribute('data-nb-nach-bild') || !poster || poster.complete;
    var steuern = function () {
      if (video.nbSelbst) return;
      if (sichtbar && bereit) video.play().catch(function () {});
      else if (!video.paused) video.pause();
    };
    if (!bereit) {
      var los = function () {
        bereit = true;
        // Einen Frame warten, damit das Bild gemalt ist, bevor das Video die Leitung belegt
        requestAnimationFrame(function () {
          setTimeout(steuern, 0);
        });
      };
      poster.addEventListener('load', los, { once: true });
      poster.addEventListener('error', los, { once: true });
    }
    new IntersectionObserver(
      function (eintraege) {
        sichtbar = eintraege[0].isIntersecting;
        steuern();
      },
      { threshold: 0.35 }
    ).observe(video);
  }

  function alle() {
    document.querySelectorAll(AUSWAHL).forEach(binden);
  }
  alle();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle);
})();
